var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { Store } from "@ngrx/store";
import * as fromRoot from "../../reducers";
import { DiagnosisDescriptionsService } from "../diagnosis/diagnosis-descriptions.service";
import { PlanDescriptionsService } from "../plan/plan-descriptions.service";
import { Observable } from "rxjs/Observable";
import { DiagnosisWidgetService } from "../diagnosis/diagnosis-widget.service";
import { PlanWidgetService } from "../plan/plan-widget.service";
import { PlanTreatmentsService } from "@app/core/store/plan-editor/plan/plan-treatments.service";
import "rxjs-spy/add/operator/tag";
import { ReplaySubject } from "rxjs/ReplaySubject";
import { PlanCalculations } from "@app/shared/utils/plan-calculations";
var ReportPreviewService = /** @class */ (function () {
    function ReportPreviewService(store, diagnosisWidgetService, planWidgetService, diagnosisDescriptionsService, planDescriptionsService, treatmentsService) {
        var _this = this;
        this.store = store;
        this.diagnosisWidgetService = diagnosisWidgetService;
        this.planWidgetService = planWidgetService;
        this.diagnosisDescriptionsService = diagnosisDescriptionsService;
        this.planDescriptionsService = planDescriptionsService;
        this.treatmentsService = treatmentsService;
        this.diagnosis$ = new ReplaySubject();
        this.plan$ = new ReplaySubject();
        this.settings$ = new ReplaySubject();
        this.diagnosisItems$ = store.select(fromRoot.getDiagnosisItems);
        this.planItems$ = store.select(fromRoot.getPlanItems);
        this.planStages$ = store.select(fromRoot.getPlanStages);
        this.customTotalText$ = store.select(fromRoot.getPlanCustomTotalText);
        this.discount$ = store.select(fromRoot.getPlanDiscount);
        this.reportName$ = store.select(fromRoot.getPlanEditorCurrentPlanName);
        this.reportPatient$ = store.select(fromRoot.getPlanEditorCurrentPatient);
        this.diagnosis360$ = store.select(fromRoot.getDiagnosis360);
        this.orthoMalocclusions$ = store.select(fromRoot.getDiagnosisOrthoMalocclusions);
        this.orthoFacial$ = store.select(fromRoot.getDiagnosisOrthoFacial);
        this.orthoTMJ$ = store.select(fromRoot.getDiagnosisOrthoTMJ);
        this.userSettings$ = store.select(fromRoot.getSettings);
        /* Diagnosis */
        Observable.combineLatest(
        // TODO: shoudln't the odontogram be fed with the diagnosisItems input? because in the report configurator user may delete items?
        this.diagnosis360$
            .filter(function (diagnosis) { return diagnosis !== null; })
            .tag("report/diagnosis/360"), this.diagnosisWidgetService
            .getOdontogram()
            .tag("report/diagnosis/odontogram"), this.diagnosisItems$.tag("report/diagnosis/items"), this.diagnosisItems$
            .flatMap(function (items) {
            return _this.diagnosisDescriptionsService.getDescriptions(items);
        })
            .tag("report/diagnosis/itemDescriptions"), this.orthoMalocclusions$.tag("report/diagnosis/orthoMalocclusions"), this.orthoFacial$.tag("report/diagnosis/orthoFacial"), this.orthoTMJ$.tag("report/diagnosis/orthoTMJ"), this.diagnosisDescriptionsService.getDescriptionsObservable(), function (diagram360, odontogram, items, descriptions, malocclusions, facial, tmj, allDescriptions) {
            var orthoDescriptions = __assign({}, _this.diagnosisDescriptionsService.getOrthoDescriptions("malocclusions", malocclusions, allDescriptions), _this.diagnosisDescriptionsService.getOrthoDescriptions("facial", facial, allDescriptions), _this.diagnosisDescriptionsService.getOrthoDescriptions("tmj", tmj, allDescriptions));
            return {
                diagram360: diagram360,
                odontogram: odontogram,
                items: items,
                descriptions: descriptions,
                ortho: {
                    malocclusions: malocclusions,
                    facial: facial,
                    tmj: tmj,
                    descriptions: orthoDescriptions,
                },
            };
        })
            .debounceTime(1000)
            .tag("report/diagnosis")
            .subscribe(this.diagnosis$);
        /* Plan */
        Observable.combineLatest(
        // TODO: shoudln't the odontogram be fed with the diagnosisItems input? because in the report configurator user may delete items?
        this.planWidgetService.getOdontogram().tag("report/plan/odontogram"), this.getPlanItems().tag("report/plan/items"), this.planItems$
            .flatMap(function (items) { return _this.planDescriptionsService.getDescriptions(items); })
            .tag("report/plan/descriptions"), this.planStages$, this.customTotalText$, this.discount$, function (odontogram, items, descriptions, stages, customTotalText, discount) {
            return __assign({ odontogram: odontogram,
                items: items,
                descriptions: descriptions, stages: stages.map(function (stage) {
                    return Object.assign({}, stage, __assign({ items: stage.items.map(function (item) {
                            var conditionClass = _this.treatmentsService.getClassForTreatment(item.treatment);
                            return Object.assign({}, item, {
                                treatment: conditionClass.getNameIdentifier(item),
                            });
                        }) }, PlanCalculations.calculateStageTotals(stage)));
                }) }, PlanCalculations.calculatePlanTotals(stages, discount), { customTotalText: customTotalText,
                discount: discount });
        })
            .debounceTime(1000)
            .tag("report/plan")
            .subscribe(this.plan$);
        /* Settings */
        Observable.combineLatest(this.reportName$, this.reportPatient$.filter(function (patient) { return patient !== null; }), this.userSettings$.filter(function (settings) { return settings !== null; }), function (name, patient, userSettings) {
            return {
                name: name,
                patient: patient.name,
                currency: userSettings.currency,
                numberingSystem: userSettings.numberingSystem,
                defaultColor: userSettings.defaultColor,
                doctor: {
                    name: userSettings.name,
                    logo: userSettings.logo,
                    contact: userSettings.contactInfo,
                },
            };
        })
            .tag("report/settings")
            .subscribe(this.settings$);
    }
    /*
     * Diagnosis
     */
    ReportPreviewService.prototype.getDiagnosis = function () {
        return this.diagnosis$;
    };
    /*
     * Plan
     */
    ReportPreviewService.prototype.getPlan = function () {
        return this.plan$;
    };
    /**
     * Transforms the treatment identifier to show in the final report because some treatments have different names depending on the options
     */
    ReportPreviewService.prototype.getPlanItems = function () {
        var _this = this;
        return this.planItems$.switchMap(function (items) {
            return Observable.of(items.map(function (item) {
                var conditionClass = _this.treatmentsService.getClassForTreatment(item.treatment);
                return Object.assign({}, item, {
                    treatment: conditionClass.getNameIdentifier(item),
                });
            }));
        });
    };
    /*
     * Other Report Settings
     */
    ReportPreviewService.prototype.getSettings = function () {
        return this.settings$;
    };
    return ReportPreviewService;
}());
export { ReportPreviewService };



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/report/report-preview.service.ts.pre-build-optimizer.js